import { default as RelatedItems } from './RelatedItems';

export default RelatedItems;
